<nouvelle-version-disponible></nouvelle-version-disponible>
<statut-alert #alertWS></statut-alert>
<communication-utilisateur-component [langue]="codeLangueUtilisateur"></communication-utilisateur-component>
<sigale-operations-admin-component></sigale-operations-admin-component>
<div>
	<app-menu></app-menu>
</div>
<ng-progress [thick]="true" [meteor]="false"></ng-progress>
<router-outlet></router-outlet>
